import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, AlertCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { AuthShell, Button, Callout, GoogleButton, PasswordInput } from '../components';
import { returnTo } from '../utils/returnTo';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, googleSignIn } = useAuth();
  const navigate = useNavigate();

  // A Google account without a pickBlink account goes to sign-up, which only asks for a name
  const handleGoogle = async (credential) => {
    setError('');
    try {
      await googleSignIn(credential);
      navigate(returnTo());
    } catch (err) {
      if (err.data?.code === 'no_account') {
        navigate('/register', { state: { google: { credential, email: err.data.email, name: err.data.name } } });
      } else {
        setError(err.message || 'Google sign-in failed');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate(returnTo());
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Sign in" subtitle="Welcome back. Sign in to start picking.">
      {error && <Callout type="error" icon={AlertCircle}>{error}</Callout>}

      <GoogleButton onCredential={handleGoogle} />

      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <label htmlFor="login-email">Email</label>
          <input
            id="login-email"
            type="email"
            className="input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            autoComplete="username"
            required
            autoFocus
          />
        </div>

        <div className="input-group">
          <label htmlFor="login-password">Password</label>
          <PasswordInput
            id="login-password"
            value={password}
            onChange={setPassword}
            placeholder="Your password"
            autoComplete="current-password"
          />
          <Link to="/forgot-password" className="login-forgot">Forgot password?</Link>
        </div>

        <Button type="submit" variant="primary" size="lg" block loading={loading} iconRight={loading ? undefined : ArrowRight}>
          {loading ? 'Signing in…' : 'Sign in'}
        </Button>
      </form>

      <p className="login-switch">
        New here? <Link to="/register">Create an account</Link>
      </p>
    </AuthShell>
  );
}

export default Login;
